import { ReactNode } from "react"
import { Button } from "../common/button";
import { Popover, PopoverContent, PopoverTrigger } from "../common/popover";
import { PopoverClose } from "@radix-ui/react-popover";
import { Loader } from "lucide-react";

type PopoverFooterButton = {
  label: string;
  className?: string;
  variant?: "default" | "destructive" | "disabled" | "ghost" | "link" | "outline" | "secondary";
  size?: "default" | "icon" | "lg" | "sm";
  onClick?: () => void;
}

type ActionButton = {
  variant?: "default" | "destructive" | "disabled" | "ghost" | "link" | "outline" | "secondary";
  size?: "default" | "icon" | "lg" | "sm";
  children: ReactNode
  onClick?: () => void;
  className?: string;
  title?: string;
  popoverContent?: ReactNode
  popoverFooterButtons?: PopoverFooterButton[]
}

type Props = {
  children: ReactNode;
  actionButtonsWrapperClassName?: string
  actionButtons: ActionButton[];
  actionLoading?: boolean;
}

function SimpleHoverWithActionButtons({ children, actionButtonsWrapperClassName, actionButtons, actionLoading }: Readonly<Props>) {
  return (
    <div className={`relative group`}>
      {children}
      <div className={`absolute flex items-center justify-center left-[50%] rounded-sm shadow-lg top-[-22px] translate-x-[-50%] invisible group-hover:visible ${actionButtonsWrapperClassName ?? ""}`}>
        {actionButtons && actionButtons.length > 0 && actionLoading &&
          <Button key="loading" variant={"outline"} size={"icon"} className={`w-5 h-5 p-1 border-0 text-blue-500 hover:text-blue-500 ${actionButtons[0].className ?? ""}`}>
            <Loader className="animate-spin" />
          </Button>
        }
        {!actionLoading && actionButtons.map((btn: ActionButton, index: number) => {
          if (!btn.popoverContent) {
            return (
              <Button key={`${btn.title ?? "" + index}`} variant={btn.variant ?? "outline"} size={btn.size ?? "icon"} className={`w-5 h-5 p-1 border-0 text-blue-500 hover:text-blue-500 ${btn.className ?? ""}`} onClick={btn.onClick}>
                {btn.children ?? btn.title ?? "Action button"}
              </Button>
            )
          }
          return (
            <Popover key={`${btn.title ?? "" + index}`}>
              <PopoverTrigger asChild>
                <Button variant={btn.variant ?? "outline"} size={btn.size ?? "icon"} className={`w-5 h-5 p-1 border-0 text-blue-500 hover:text-blue-500 ${btn.className ?? ""}`} onClick={btn.onClick}>
                  {btn.children ?? btn.title ?? "Action button"}
                </Button>
              </PopoverTrigger>
              <PopoverContent>
                {btn.popoverContent}
                {btn.popoverFooterButtons && btn.popoverFooterButtons?.length > 0 &&
                  <PopoverClose className="w-full">
                    {btn.popoverFooterButtons.map((footerBtn: PopoverFooterButton, footerIndex: number) => (
                      <Button
                        key={`${footerBtn.label ?? "" + footerIndex}`}
                        className={`my-2 w-full ${footerBtn.className}`}
                        size={footerBtn.size ?? "sm"}
                        variant={footerBtn.variant ?? "default"}
                        onClick={footerBtn.onClick}
                      >
                        {footerBtn.label}{" "}
                      </Button>
                    ))}
                  </PopoverClose>
                }
              </PopoverContent>
            </Popover>
          )
        })}
      </div>
    </div>
  )
}

export default SimpleHoverWithActionButtons